import t, { useEffect as e, useRef as r, useCallback as n, useState as o, forwardRef as c, useImperativeHandle as s } from "react";
import { createPortal as i } from "react-dom";
function l(t) {
  return t ? "hidden" : "auto";
}
function a(t, e, r, n) {
  void 0 === n && (n = 20);
  const o = e - r,
    c = Math.max(n, o / t * o);
  return {
    thumbSize: c,
    ratio: (o - c) / (t - e)
  };
}
function u(t, e, r) {
  t && (r ? t.scrollLeft = e : t.scrollTop = e);
}
function m(t) {
  const e = r(t);
  return e.current = t, e;
}
function p(t, r, n, o) {
  const c = m(r);
  e(() => {
    function e(t) {
      c.current(t);
    }
    const r = n ? n() : window;
    return r && r.addEventListener(t, e, o), () => {
      r && r.removeEventListener(t, e);
    };
  }, []);
}
function d(t, o) {
  let {
    leading: c = !1,
    maxWait: s,
    wait: i = s || 0
  } = o;
  const l = m(t),
    a = r(0),
    u = r(),
    p = () => u.current && clearTimeout(u.current);
  return e(() => () => {
    a.current = 0, p();
  }, [i, s, c]), n(function () {
    var t = [].slice.call(arguments);
    const e = Date.now();
    function r() {
      a.current = e, p(), l.current.apply(null, t);
    }
    const n = a.current,
      o = e - n;
    if (0 === n) {
      if (c) return void r();
      a.current = e;
    }
    if (void 0 !== s) {
      if (o > s) return void r();
    } else o < i && (a.current = e);
    p(), u.current = setTimeout(() => {
      r(), a.current = 0;
    }, i);
  }, [i, s, c]);
}
function f(e) {
  let {
    scrollRef: r,
    visible: n,
    trackStyle: o,
    thumbStyle: c,
    minThumbSize: s,
    start: i,
    gap: l,
    horizontal: u,
    pin: m,
    trackRef: p,
    boxSize: d,
    update: f,
    onScroll: S
  } = e;
  const {
      CW: h,
      CH: b,
      PT: v,
      PR: g,
      PB: y,
      PL: k,
      SW: T,
      SH: C
    } = d,
    [Y, w, H] = u ? ["width", h, T] : ["height", b, C],
    L = {
      ...(void 0 !== typeof document && r.current === document.documentElement ? {
        [Y]: l > 0 ? `calc(100% - ${l}px)` : void 0
      } : {
        [Y]: w - l,
        ...(u ? {
          bottom: -y,
          left: -k + i
        } : {
          top: v - l + i,
          right: -g,
          transform: "translateY(-100%)"
        })
      }),
      ...(o && o(u))
    };
  return t.createElement("div", {
    className: `ms-track${u ? " ms-x" : " ms-y"}${m ? " ms-active" : n ? " ms-track-show" : ""}`,
    onClick: function (t) {
      const e = r.current,
        {
          scrollLeft: n,
          scrollTop: o
        } = e,
        c = u ? n : o,
        s = t.target.getBoundingClientRect(),
        i = (u ? (t.clientX - s.left) / s.width : (t.clientY - s.top) / s.height) > c / H ? Math.min(H, c + w) : Math.max(0, c - w);
      S(i, u);
    },
    ref: p,
    style: L
  }, t.createElement("div", {
    className: "ms-thumb",
    draggable: !0,
    onDragStartCapture: t => {
      t.preventDefault(), t.stopPropagation();
    },
    onMouseDown: function (t) {
      t.stopPropagation();
      const {
        scrollLeft: e,
        scrollTop: n
      } = r.current;
      f({
        pinX: u,
        pinY: !u,
        lastST: n,
        lastSL: e,
        startX: t.clientX,
        startY: t.clientY
      });
    },
    onClick: t => t.stopPropagation(),
    style: {
      [Y]: a(H, w, l, s).thumbSize,
      ...(c && c(u))
    }
  }));
}
const S = {
    CW: 0,
    SW: 0,
    CH: 0,
    SH: 0,
    PT: 0,
    PR: 0,
    PB: 0,
    PL: 0
  },
  h = {
    pinX: !1,
    pinY: !1,
    lastST: 0,
    lastSL: 0,
    startX: 0,
    startY: 0
  };
function b(c, s, i) {
  let {
    skin: l = "light",
    trackGap: u = 16,
    trackStyle: m,
    thumbStyle: b,
    minThumbSize: v,
    suppressAutoHide: g,
    suppressScrollX: y,
    suppressScrollY: k
  } = void 0 === i ? {} : i;
  const T = r(null),
    C = r(null),
    [Y, w] = o(S),
    [H, L] = o(h),
    [P, W] = o(!0),
    X = d(() => !g && W(!1), {
      wait: 1e3
    }),
    {
      CW: x,
      SW: z,
      CH: E,
      SH: R
    } = Y,
    $ = z - x > 0,
    M = R - E > 0,
    [A, B, N, D] = function (t, e, r) {
      let n = t;
      if ("function" == typeof n && (n = n(e, r)), Array.isArray(n)) {
        const [t, e, r, o] = n;
        return [t, t + e, r, r + o];
      }
      const o = e && r ? n : 0;
      return [0, o, 0, o];
    }(u, $, M),
    I = d(t => {
      W(!0), X(), function (t, e, r, n, o, c, s) {
        const {
            SW: i,
            SH: l,
            CW: u,
            CH: m
          } = t,
          {
            scrollTop: p,
            scrollLeft: d
          } = e;
        if (r) {
          const t = d * a(i, u, o, s).ratio;
          r.firstChild.style.transform = `translateX(${t}px)`;
        }
        if (n) {
          const t = p * a(l, m, c, s).ratio;
          n.firstChild.style.transform = `translateY(${t}px)`;
        }
      }(Y, t, T.current, C.current, B, D, v);
    }, {
      maxWait: 8,
      leading: !0
    });
  p("mousemove", t => {
    if (H.pinX) {
      const e = a(z, x, B, v).ratio;
      s(Math.floor(1 / e * (t.clientX - H.startX) + H.lastSL), !0);
    }
    if (H.pinY) {
      const e = a(R, E, D, v).ratio;
      s(Math.floor(1 / e * (t.clientY - H.startY) + H.lastST));
    }
  }, void 0, {
    capture: !0
  }), p("mouseup", () => L(h));
  const G = n(() => {
    c.current && (w(function (t) {
      const {
          paddingTop: e,
          paddingRight: r,
          paddingBottom: n,
          paddingLeft: o
        } = window.getComputedStyle(t),
        {
          clientWidth: c,
          scrollWidth: s,
          clientHeight: i,
          scrollHeight: l
        } = t;
      return {
        CW: c,
        SW: s,
        CH: i,
        SH: l,
        PT: parseInt(e, 10),
        PR: parseInt(r, 10),
        PB: parseInt(n, 10),
        PL: parseInt(o, 10)
      };
    }(c.current)), I(c.current));
  }, []);
  return p("mouseenter", G, () => c.current), p("mouseleave", X, () => c.current), function (t, r) {
    const n = d(r, {
      maxWait: 8,
      leading: !0
    });
    e(() => {
      const e = new ResizeObserver(() => {
          n();
        }),
        r = new MutationObserver(() => {
          o();
        });
      function o() {
        t.current && (t.current === document.documentElement ? e.observe(document.body) : (e.observe(t.current), Array.from(t.current.children).forEach(t => {
          e.observe(t);
        })));
      }
      return t.current && r.observe(t.current, {
        childList: !0
      }), o(), () => {
        e.disconnect(), r.disconnect();
      };
    }, [t]);
  }(c, G), [t.createElement("div", {
    className: `ms-track-box ms-theme-${l}`
  }, !y && $ && t.createElement(f, {
    scrollRef: c,
    visible: P,
    trackStyle: m,
    thumbStyle: b,
    minThumbSize: v,
    start: A,
    gap: B,
    horizontal: !0,
    pin: H.pinX,
    trackRef: T,
    boxSize: Y,
    update: L,
    onScroll: s
  }), !k && M && t.createElement(f, {
    scrollRef: c,
    visible: P,
    trackStyle: m,
    thumbStyle: b,
    minThumbSize: v,
    start: N,
    gap: D,
    pin: H.pinY,
    trackRef: C,
    boxSize: Y,
    update: L,
    onScroll: s
  })), I, G];
}
const v = c((e, n) => {
  let {
    className: o = "",
    onScroll: c,
    children: i,
    style: a,
    skin: m,
    trackGap: p,
    trackStyle: d,
    thumbStyle: f,
    minThumbSize: S,
    suppressAutoHide: h,
    suppressScrollX: v,
    suppressScrollY: g,
    as: y = "div",
    ...k
  } = e;
  const T = r(null);
  s(n, () => T.current);
  const [C, Y] = b(T, (t, e) => u(T.current, t, e), {
    skin: m,
    trackGap: p,
    trackStyle: d,
    thumbStyle: f,
    minThumbSize: S,
    suppressAutoHide: h,
    suppressScrollX: v,
    suppressScrollY: g
  });
  return t.createElement(y, {
    className: `ms-container${o && ` ${o}`}`,
    ref: T,
    onScroll: function (t) {
      c && c(t), Y(t.target);
    },
    style: {
      overflowX: l(v),
      overflowY: l(g),
      ...a
    },
    ...k
  }, C, i);
});
function g(t) {
  const e = r(document.documentElement),
    [n, o] = b(e, (t, r) => u(e.current, t, r), t);
  return p("scroll", () => o(e.current)), i(n, document.body);
}
function y(r) {
  const [n, c] = o(!1);
  return e(() => {
    c(!0);
    const t = "ms-global",
      {
        classList: e
      } = document.body;
    return e.add(t), () => {
      c(!1), e.remove(t);
    };
  }, []), t.createElement(t.Fragment, null, n && t.createElement(g, {
    ...r
  }));
}
export { y as GlobalScrollbar, v as MacScrollbar, b as useScrollbar };